export default {
  messages: [],
  chat: null,
  conversation: null,
  channels: [],
  chatWidget: {
    open: false,
    recipient: {},
    message: '',
  }
}
